import { ReceivableStateTypes, ReceivableActionTypes } from "./Receivable.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: ReceivableStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const ReceivableReducer = (
  state: ReceivableStateTypes = INITIAL_STATE,
  action: any
): ReceivableStateTypes => {
  switch (action.type) {
    case ReceivableActionTypes.FETCH_ALL_RECEIVABLE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case ReceivableActionTypes.FETCH_ALL_RECEIVABLE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case ReceivableActionTypes.FETCH_ALL_RECEIVABLE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ReceivableActionTypes.FETCH_ALL_RECEIVABLE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case ReceivableActionTypes.FETCH_ONE_RECEIVABLE:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case ReceivableActionTypes.FETCH_ONE_RECEIVABLE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case ReceivableActionTypes.FETCH_ONE_RECEIVABLE_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ReceivableActionTypes.FETCH_ONE_RECEIVABLE_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default ReceivableReducer;
